import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface StatItem {
  date: Date;
  concentric: number;
  eccentric: number;
  w: number;
  nm: number;
  reps: number;
  kg: number;
}

export interface StatsResponse {
  loadInTime: StatItem[];
}

const queryOptions = (machineType: string) => ({
  queryKey: ['stats', machineType],
  queryFn: async () => {
    if (!machineType) {
      throw new Error('No machine type selected');
    }
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.post<StatsResponse>(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/stats`,
        { machineType, monthsAmount: 12 },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if ( error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key"
      ) { 
        logout()
      } 
      throw error;
    } 
  },
  enabled: !!machineType,
}) as any;

export const useStats = (machineType: string) => {
  return useQuery<StatsResponse, Error>(queryOptions(machineType));
};
